<template>
  <div class="flex flex-col bg-[#080C25] pt-4 pb-6 px-4 rounded-xl">
    <div class="flex items-center px-4">
      <OLink class="flex items-center mr-2 sm:mr-0" href="/yasam/astroloji">
        <span class="flex items-center self-stretch text-[#A5B2EC] text-lg leading-26 font-semibold">Astroloji</span>
      </OLink>
    </div>
    <div class="border-b border-[#2F3656] w-full my-4"></div>
    <div class="u-center flex-wrap gap-6">
      <div v-for="item in horoscopes" :key="item.name">
        <OLink :href="item.route" class="horoscope-wrapper flex flex-col items-center" @click="handleClickHoroscope()">
          <div class="rounded-full bg-[#161E35] p-5 mb-4">
            <OIcon :icon="`homepage/horoscope/${item.icons.iconCode}`" width="24" height="24" />
          </div>
          <span class="text-white text-base leading-18 tracking-tight font-medium">{{ item.name }}</span>
        </OLink>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { OLink, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: { OLink, OIcon },
  setup() {
    const { sendKesfetEvent } = onedioEvents();
    const { isMobile } = useDevice();
    const horoscopes = [
      {
        name: 'Koç',
        route: '/yasam/astroloji/koc-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/koc-burcu.png',
          iconCode: 'aries',
        },
      },
      {
        name: 'Boğa',
        route: '/yasam/astroloji/boga-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/boga-burcu.png',
          iconCode: 'taurus',
        },
      },
      {
        name: 'İkizler',
        route: '/yasam/astroloji/ikizler-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/ikizler-burcu.png',
          iconCode: 'gemini',
        },
      },
      {
        name: 'Yengeç',
        route: '/yasam/astroloji/yengec-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/yengec-burcu.png',
          iconCode: 'cancer',
        },
      },
      {
        name: 'Aslan',
        route: '/yasam/astroloji/aslan-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/aslan-burcu.png',
          iconCode: 'leo',
        },
      },
      {
        name: 'Başak',
        route: '/yasam/astroloji/basak-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/basak-burcu.png',
          iconCode: 'virgo',
        },
      },
      {
        name: 'Terazi',
        route: '/yasam/astroloji/terazi-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/terazi-burcu.png',
          iconCode: 'libra',
        },
      },
      {
        name: 'Akrep',
        route: '/yasam/astroloji/akrep-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/akrep-burcu.png',
          iconCode: 'scorpio',
        },
      },
      {
        name: 'Yay',
        route: '/yasam/astroloji/yay-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/yay-burcu.png',
          iconCode: 'sagittarius',
        },
      },
      {
        name: 'Oğlak',
        route: '/yasam/astroloji/oglak-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/oglak-burcu.png',
          iconCode: 'capricorn',
        },
      },
      {
        name: 'Kova',
        route: '/yasam/astroloji/kova-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/kova-burcu.png',
          iconCode: 'aquarius',
        },
      },
      {
        name: 'Balık',
        route: '/yasam/astroloji/balik-burcu',
        icons: {
          png: 'https://static.onedio.com/icons/burclar/balik-burcu.png',
          iconCode: 'pisces',
        },
      },
    ];

    const handleClickHoroscope = () => {
      sendKesfetEvent('Sidebar', 'Click', 'Astroloji');
    };

    return { horoscopes, isMobile, handleClickHoroscope };
  },
});
</script>
<style scoped lang="scss">
.horoscope-wrapper {
  &:hover {
    transform: scale(1.1);
    transition: all 0.2s 0s ease-in;
  }
}
</style>
